import { Expose, Type } from 'class-transformer';

import { Default } from '@lib/common/decorators';

import { SnIntegrationLayer } from '../integration-layer';
import { SnLayerMeta } from '../layer-meta';

export class SnFirstTwoMeta extends SnLayerMeta {
  @Expose()
  @Default('')
  public apiUserName: string;

  @Expose()
  @Default('')
  public apiPassword: string;

  @Expose()
  @Default('')
  public onBehalfOf: string;

  @Expose()
  @Default('')
  public location: string;
}

export class SnFirstTwoLayer extends SnIntegrationLayer {
  @Expose()
  @Default('FirstTwo Integration')
  public name: string;

  @Expose()
  @Default('FirstTwo')
  public integrationType: string;

  @Expose()
  @Type(() => SnFirstTwoMeta)
  @Default(new SnFirstTwoMeta())
  public meta: SnFirstTwoMeta;
}
